(ns cms.fetch
  (:require 
    [promises.core :refer-macros [await->]]
    [clojure.string :as str]))

(def default-headers& (atom {"X-App-Id" "net.musopia.musopiano"}))

(defn fetch [url & {:as options}]
  (await-> 
    (js/fetch url
              (-> options
                  (update :headers merge @default-headers&)
                  (clj->js)))    
    (then [^js response] 
          (let [ctype (.get (.-headers response) "content-type")
                headers 
                (let [m (transient {})]
                  (.forEach (.-headers response) (fn [v k] (assoc! m k v)))
                  (persistent! m))]
            (await-> 
              (if (some-> ctype (str/includes? "application/json"))
                (.json response)
                (.text response))
              (then  
                [body] 
                {:body (js->clj body)
                 :status (.-status response)
                 :status-text (.-statusText response)
                 :headers headers
                 :ok (.-ok response)}))))
    (then [{:keys [ok body status status-text] :as resp}]
          (println resp)
          (when-not ok
            (throw (ex-info "Error in web request"
                            {:status      status
                             :status-text status-text
                             :body        body})))
          resp)))